import { useAuthStore } from "../../stores/authStore";
import { hasPermission, isAdminRole } from "../utils/permissions";

/** Returns true if the current user has the given permission (mirrors backend PermissionHandler). */
export function usePermission(permission: string): boolean {
  const user = useAuthStore((x) => x.user);
  if (!user) return false;
  return hasPermission(user.permissions, user.roles, permission);
}

/** Returns true if the current user holds an admin role (full system access). */
export function useIsAdmin(): boolean {
  const roles = useAuthStore((x) => x.user?.roles ?? []);
  return isAdminRole(roles);
}
